// extracted by mini-css-extract-plugin
module.exports = {"newsletter_signup":"newsletter-signup_newsletter_signup__jXQlX"};